import axios from './axios'
import config from '../config'
import SectionsPage from '../components/pages/SectionsPage'
import SectionsPageConfig from '../components/pages/SectionsPageConfig'
import ReportsPage from '../components/pages/ReportsPage'
import ReportsPagePreview from '../components/pages/ReportsPagePreview'
import CompanyMonitorPage from '../components/pages/CompanyMonitorPage'
import CompanyMonitorPagePreview from '../components/pages/CompanyMonitorPagePreview'

const pageTypes = [
    {
        type: 'sections',
        typeName: '栏目页面',
        component: SectionsPage,
        config: SectionsPageConfig
    },
    {
        type: 'reports',
        typeName: '舆情报告页面',
        component: ReportsPage,
        preview: ReportsPagePreview
    },
    {
        type: 'company_monitor',
        typeName: '风险监测页面',
        component: CompanyMonitorPage,
        preview: CompanyMonitorPagePreview
    }
]

const pageTypeMap = new Map()
for (const pageType of pageTypes) {
    pageTypeMap.set(pageType.type, pageType)
}

export default {
    getPageType(type) {
        return pageTypeMap.get(type)
    },
    getPageTypes() {
        return pageTypes
    },
    async getAssignedPageTypes(){
        const response = await axios({
            url: config.backendUrl + '/common/pages/assigned-types',
            method: 'GET',
        })
        return response.data.map(item => pageTypeMap.get(item))
    }
}
